export default __webpack_public_path__ + "imgs/logo.49f2ecf3.png";